<div class="image-upload-container">
  <input
    formControlName="images"
    type="file"
    class="file-input"
    #fileField
    (change)="handleFileChange($event)"
    class="hide"
    accept="svs; tiff"
    multiple="multiple"
  />
  <div class="controls">
    <button
      type="button"
      mat-raised-button
      class="btn btn-primary importer"
      (click)="triggerSelection()"
    >
      {{ labels.UPLOAD }}
    </button>
    
  </div>
  <div class="image-list" *ngIf="currentImagesData.length > 0">
    <div class="image_card" *ngFor="let cid of currentImagesData; let idx = index">
      <div class="close-container" *ngIf="cid.ready">
        <i
          class="fas fa-circle-xmark close-icon"
          (click)="removeImage(cid.image)"
          tabindex="0"
        ></i>
      </div>
      <div class="image_thumb">
        <img
          *ngIf="cid.ready"
          class="slide-thumb"
          src="{{ cid.image.thumb_src }}"
          alt="Image thumbnail"
        />
        
        <div class="progress" *ngIf="uploadProgress > 0 && !cid.ready">
          <span class="image-title">{{ cid.name }}</span>
                <!--<mat-progress-bar class="progress-bar" [value]="uploadProgress" mode="determinate"></mat-progress-bar>-->
          <mat-progress-spinner
            *ngIf="cid.currentlyUploading"
            diameter="20"
            color="primary"
            mode="determinate"
            [value]="uploadProgress"
          >
          </mat-progress-spinner>
        </div>
        <!--<span class="image-name">{{ img.friendlyName }}</span>-->
      </div>
    </div>
  </div>
</div>
